import { useRedirectIfUnauthenticated } from "utils/azureAD/useRedirectIfUnauthenticated";
import { useMutation } from "react-query";
import fetchWrapper, {
  AsyncResponseData,
  constructResponseData,
} from "utils/fetchWrapper/fetchWrapper";

type updateOrderData = {
  id: string;
  name: string;
  source?: string;
  externalId?: string;
  categoryOrder: number;
};

type updateOrderDTO = {
  username: string;
  data: updateOrderData[];
};

const updateOrderAsync = async ({username, data}: updateOrderDTO): Promise<AsyncResponseData<void>> => {
  const response = await fetchWrapper.put(`${process.env.REACT_APP_BACK_END_API}/${username}/categories/update-order`, data);

  const failureMessage = "La mise à jour des catégories a échoué";

  const updateCategoriesOrderData = await constructResponseData<void>(response, failureMessage);

  return updateCategoriesOrderData;
};

export const useUpdateCategoriesOrderAsync = () => {
  const { accounts } = useRedirectIfUnauthenticated();
  const username = accounts?.[0]?.username;

  return useMutation((data: updateOrderData[]) => updateOrderAsync({username, data}));
};
